import React from 'react';

import { StyledContainer } from './styles';
import type { ContainerProps } from './types';

export default function Container({
  paddingBottom,
  paddingTop,
  ...props
}: ContainerProps) {
  return (
    <StyledContainer
      maxWidth="xl"
      css={{
        paddingBottom,
        paddingTop,
      }}
      {...props}
    />
  );
}
